import React from 'react';

const WEB = () => {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.5 19a2 2 0 1 1 0-4 2 2 0 0 1 0 4zM12.498 10c2.383-.008 4.672.893 6.363 2.508.162.153.266.346.306.55.04.204.017.42-.075.618-.092.2-.245.362-.43.47-.188.11-.41.167-.648.154a1.127 1.127 0 0 1-.775-.319 6.837 6.837 0 0 0-4.742-1.892c-1.779 0-3.485.681-4.74 1.891a1.124 1.124 0 0 1-.78.309c-.28 0-.563-.103-.777-.308a1.023 1.023 0 0 1-.317-.737c0-.267.106-.534.316-.737 1.675-1.599 3.938-2.5 6.3-2.507z" fill="#000" />
      <path d="M12.498 5c3.74.01 7.325 1.435 9.979 3.97.206.196.322.463.322.742 0 .28-.116.547-.322.743a1.13 1.13 0 0 1-.787.307 1.127 1.127 0 0 1-.783-.306c-2.323-2.23-5.366-3.346-8.409-3.346-3.043 0-6.086 1.116-8.409 3.346-.216.208-.5.312-.784.312-.284 0-.568-.104-.785-.312a1.028 1.028 0 0 1-.32-.743c0-.27.107-.539.32-.743C5.173 6.435 8.759 5.01 12.498 5z" fill="#000" />
    </svg>

  );
};

export default WEB;
